import request from '@/utils/request'

// 财税实操--列表
export function findCSSCList (data) {
    return request({
        url: `/system/training/getCourseList`,
        method: 'get',
        params: {}
    })
}

// 财税实操--进入学习、考试
export function enterCSSC (paperId) {
    return request({
        url: `/system/training/getCourseLink/${paperId}`,
        method: 'get',
    })
}

// 财税实操--考试结果查看
export function findCSSCRes (id) {
    return request({
        url: `/system/training/getExerciseRecordLink/${id}`,
        method: 'get',
    })
}

// 财税实操--进入考试
export function enterCSSCExam (paperId) {
    return request({
        url: `/system/training/getExamLink/${paperId}`,
        method: 'get',
    })
}

// 开始练习
export function startExercise (id) {
    return request({
        url: `/system/exam/createExercise?paperId=${id}`,
        method: 'get',
        params: {}
    })
}

// 开始仁和真账实训练习
export function startRhCloudExercise (id) {
  return request({
    url: `/system/exam/createRhCloudExercise?paperId=${id}`,
    method: 'post',
    params: {}
  })
}

// 财税实操--用友练习记录
export function findExerciseOut (paperId) {
    return request({
        url: `/system/training/getExerciseRecordList/${paperId}`,
        method: 'get',
    })
}


// 真账实训-- 获取代账软件单点登录地址
export function getSingleLoginUrl () {
    return request({
        url: '/system/newTraining/getSingleLoginUrl',
        method: 'get'
    })
}

// 真账实训-- 财税实操--列表
export function getRhCourseList (data) {
    return request({
        url: `/system/training/getRhCourseList`,
        method: 'get',
        params: {}
    })
}
